import moment from "moment"

export const overviewDataRenderList = [
	{
		name: '消耗',
		key: 'cost',
		updateDateKey: 'costTime'
	},
	{
		name: 'GMV',
		key: 'customerOrderValidTotalSalePrice',
		updateDateKey: 'defaultTime'
	},
	{
		name: '投入产出比',
		key: 'inputOutputRatio',
		updateDateKey: 'defaultTime'
	},
	{
		name: '订单数',
		key: 'customerOrderNum',
		updateDateKey: 'defaultTime'
	},
	{
		name: '有效订单数',
		key: 'customerOrderValidNum',
		updateDateKey: 'defaultTime'
	}
]

export const chartsTypeOptions = [
	{
		name: '消耗',
		key: 'cost',
		updateDateKey: 'costTime'
	},
	{
		name: 'GMV',
		key: 'customerOrderValidTotalSalePrice',
		updateDateKey: 'defaultTime'
	},
	{
		name: '投入产出比',
		key: 'inputOutputRatio',
		updateDateKey: 'defaultTime'
	},
	{
		name: '订单数',
		key: 'customerOrderNum',
		updateDateKey: 'defaultTime'
	},
	{
		name: '有效订单数',
		key: 'customerOrderValidNum',
		updateDateKey: 'defaultTime'
	}
]


export const overviewPlanDataRenderList = [
	{
		name: '消耗',
		key: 'cost',
		updateDateKey: 'costTime'
	},
	{
		name: 'GMV',
		key: 'orderValidTotalSalePrice',
		updateDateKey: 'defaultTime'
	},
	{
		name: '投入产出比',
		key: 'inputOutputRatio',
		updateDateKey: 'defaultTime'
	},
	{
		name: '订单数',
		key: 'orderNum',
		updateDateKey: 'defaultTime'
	},
	{
		name: '有效订单数',
		key: 'orderValidNum',
		updateDateKey: 'defaultTime'
	}
]




export const renderSearchList = [
	{
		label: '选择日期',
		key: 'dates',
		type: 'datePicker',
		width: 216,
		datePickerType: 'daterange',
		placeholder: '请选择',
		maxDate: moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
		//datePickerConfirm: true
	},
	{
		label: '指标',
		key: 'chartsType',
		type: 'select',
		width: 114,
		placeholder: '请选择',
		clearable: false,
		options: chartsTypeOptions.map((item) => {
			return {
				label: item.name,
				value: item.key
			}
		})
	},
]


// WEBPACK FOOTER //
// ./src/pages/home/overviewData/overviewData/config.js